require("dotenv").config();
const URL = process.env.REACT_APP_API_URL || "http://localhost/api/";
const URL_TOKEN =
  process.env.REACT_APP_TOKEN_URL || "http://localhost/oauth/token";
const LOCALHOST_URL =
  process.env.REACT_APP_API_LOCALHOST_URL || "http://localhost/";
export default {
  user: URL + "user",
  token: URL_TOKEN,
  changeResetedPassword: URL + "password/reset",
  changePassword: URL + "password/change",
  resetPassword: URL + "password/create",
  resendPassword: URL + "password/resend",
  findToken: URL + "password/find",
  providers() {
    return {
      get: id => URL + "contacts/provider/" + id,
      pendingToInvoice: () => URL + "provider/my-pending-vouchers",
      proccessed: () => URL + "provider/my-vouchers"
    };
  },
  budgets() {
    return {
      get: work_order_id => URL + "provider/budget/" + work_order_id
    };
  },

  work_order() {
    return {
      vouchers: id => URL + "ot/" + id + "/vouchers",
      novouchers: () => URL + "ots/vouchers/pending"
    };
  },
  vouchers() {
    return {
      index: id => URL + "provider/my-pending-vouchers",
      tasks_available: id => URL + "ot/" + id + "/voucher/tasks_available",
      post: () => URL + "provider/voucher"
    };
  },
  voucher_types: URL + "voucher_types",
  iva_types: URL + "iva_types",
  iva_conditions: URL + "iva_conditions",
  invoice_types: URL + "invoice_types ",
  media_download: URL + "media/download",
  media_path: URL + "media/path",
  hansa_media_download: URL + "hansa/download",
  payment_deals: URL + "payment_deals",
  payment_methods: URL + "payment_methods"
};
